export default __webpack_public_path__ + "static/media/bighead.f0ce0414.png";